'use strict';

export const duration=750;
export const easing='ease-out';
export const enterAnimation='fade'; // fade // elevator
export const leaveAnimation='fade'; // fade // elevator
export const transitionAppear = true;
export const transitionAppearTimeout = 500;
export const transitionName = "pop-in-list";
export const transitionEnterTimeout = 500;
export const transitionLeaveTimeout = 300;



// WEBPACK FOOTER //
// ./src/js/config/style/FlipMoveListConfig.js